exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-address {\n  width: 100%;\n  padding: 0 !important;\n}\n.create-address .vti__dropdown {\n    left: 5px;\n}\n", ""]);

// exports
